import { Injectable } from '@angular/core';

export interface ExperiencePageState {
  // Selected values
  selectedLanguage: any;
  selectedDate: Date | null;
  selectedTime: any;
  labelCounts: number[];
  numberOfPeople: number;
  peopleTotalPrice: number;
  extraTotalPrice: number;
  combinedTotalPrice: number;
  
  // Form data
  formData: {
    language: string;
    date: string;
    time: string;
    people: number[];
    extras: string;
  };
  
  // UI state
  isLanguageSelected: boolean;
  isLanguageAndDateSelected: boolean;
  isLanguageDateAndTimeSelected: boolean;
  isDateSelected: boolean;
  isReservation: boolean;
  selectedTab: string;
  
  // Experience info for URL
  experienceId: string;
  experienceName: string;
}

@Injectable({
  providedIn: 'root'
})
export class ExperienceStateService {
  private state: ExperiencePageState | null = null;

  saveState(state: ExperiencePageState): void {
    this.state = JSON.parse(JSON.stringify(state)); // Deep clone
  }

  getState(): ExperiencePageState | null {
    return this.state;
  }

  clearState(): void {
    this.state = null;
  }

  hasState(): boolean {
    return this.state !== null;
  }
}
